import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    title: {
        id: '_.modal.manual_payment.title',
        defaultMessage: 'Make an early repayment'
    },
    subTitle: {
        id: '_.modal.manual_payment.sub_title',
        defaultMessage:
            'Make an early repayment of {amount} via bank transfer using the following account details.'
    },
    warningMessage: {
        id: '_.modal.manual_payment.warning_message',
        defaultMessage: 'Please ensure you use the correct reference number.'
    },
    cancel: {
        id: '_.modal.manual_payment.cancel',
        defaultMessage: 'Cancel'
    },
    sentMoney: {
        id: '_.modal.manual_payment.sent_money',
        defaultMessage: "I've sent the money"
    },
    accountNumber: {
        id: '_.modal.manual_payment.account_nunmber',
        defaultMessage: 'Account number'
    },
    sortCode: {
        id: '_.modal.manual_payment.sort_code',
        defaultMessage: 'Sort code'
    },
    iban: {
        id: '_.modal.manual_payment.iban',
        defaultMessage: 'IBAN'
    },
    referenceName: {
        id: '_.modal.manual_payment.reference_name',
        defaultMessage: 'Name'
    },
    referenceID: {
        id: '_.modal.manual_payment.reference_id',
        defaultMessage: 'Reference'
    },
    returnToDashboard: {
        id: '_.navigation.return_to_dashboard',
        defaultMessage: 'Return to dashboard'
    }
});
